import { NoBlending, ShaderMaterial, Uniform } from "three";

import vertexShader from "./glsl/Common.vert";
import fragmentShaderSource from "./glsl/Vibrance.frag";
import blendFunctions from "./glsl/BlendFunctions.frag";
import blendMode from "./glsl/BlendMode.frag";

/**
 * A simple copy shader material.
 */

export class VibranceMaterial extends ShaderMaterial {

    /**
     * Constructs a new ACES material.
     */

    constructor(curveTexture) {
        let fragmentShader = fragmentShaderSource.replace("BLEND_FUNCTIONS;", blendFunctions);
        fragmentShader = fragmentShader.replace("BLEND_MODE;", blendMode);

        super({
            name: "VibranceMaterial",
            uniforms: {
                inputBuffer: new Uniform(null),
                opacity: new Uniform(1.0),
                vibrance: new Uniform(0),
                blendID: new Uniform(0)
            },
            blending: NoBlending,
            depthWrite: false,
            depthTest: false,
            fragmentShader,
            vertexShader
        });

        /** @ignore */
        this.toneMapped = false;

    }


    /**
     * The input buffer.
     *
     * @type {Texture}
     */

    set inputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Sets the input buffer.
     *
     * @deprecated Use inputBuffer instead.
     * @param {Number} value - The buffer.
     */

    setInputBuffer(value) {

        this.uniforms.inputBuffer.value = value;

    }

    /**
     * Returns the opacity.
     *
     * @deprecated Use opacity instead.
     * @return {Number} The opacity.
     */

    getOpacity(value) {

        return this.uniforms.opacity.value;

    }

    /**
     * Sets the opacity.
     *
     * @deprecated Use opacity instead.
     * @param {Number} value - The opacity.
     */

    setOpacity(value) {

        this.uniforms.opacity.value = value;

    }

}
